/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import type { Client, RequestConfig, ResponseErrorConfig } from "../../clients/api-v2-client";
import type { AuditReportsGetGipMetadataParamsForOrderQueryResponse, AuditReportsGetGipMetadataParamsForOrderQueryParams, AuditReportsGetGipMetadataParamsForOrder401, AuditReportsGetGipMetadataParamsForOrder403 } from "../models/AuditReportsGetGipMetadataParamsForOrder";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { auditReportsGetGipMetadataParamsForOrder } from "../axios/auditReportsGetGipMetadataParamsForOrder";
import { queryOptions, useQuery } from "@tanstack/react-query";

export const auditReportsGetGipMetadataParamsForOrderQueryKey = (params: AuditReportsGetGipMetadataParamsForOrderQueryParams) => ["api-v2", { url: '/audit-reports/v1/reports/gip/metadata/params-for-order' }, ...(params ? [params] : [])] as const

export type AuditReportsGetGipMetadataParamsForOrderQueryKey = ReturnType<typeof auditReportsGetGipMetadataParamsForOrderQueryKey>

export function auditReportsGetGipMetadataParamsForOrderQueryOptions(params: AuditReportsGetGipMetadataParamsForOrderQueryParams, config: Partial<RequestConfig> & { client?: Client } = {}) {

        const queryKey = auditReportsGetGipMetadataParamsForOrderQueryKey(params)
        return queryOptions<AuditReportsGetGipMetadataParamsForOrderQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataParamsForOrder401 | AuditReportsGetGipMetadataParamsForOrder403>, AuditReportsGetGipMetadataParamsForOrderQueryResponse, typeof queryKey>({
         enabled: !!(params),
         queryKey,
         queryFn: async ({ signal }) => {
            return auditReportsGetGipMetadataParamsForOrder(params, { ...config, signal: config.signal ?? signal })
         },
        })

}

/**
 * @summary Return GIP report params for order id(s)
 * {@link /audit-reports/v1/reports/gip/metadata/params-for-order}
 */
export function useAuditReportsGetGipMetadataParamsForOrder<TData = AuditReportsGetGipMetadataParamsForOrderQueryResponse, TQueryData = AuditReportsGetGipMetadataParamsForOrderQueryResponse, TQueryKey extends QueryKey = AuditReportsGetGipMetadataParamsForOrderQueryKey>(params: AuditReportsGetGipMetadataParamsForOrderQueryParams, options: 
{
  query?: Partial<QueryObserverOptions<AuditReportsGetGipMetadataParamsForOrderQueryResponse, ResponseErrorConfig<AuditReportsGetGipMetadataParamsForOrder401 | AuditReportsGetGipMetadataParamsForOrder403>, TData, TQueryData, TQueryKey>> & { client?: QueryClient },
  client?: Partial<RequestConfig> & { client?: Client }
}
 = {}) {

         const { query: queryConfig = {}, client: config = {} } = options ?? {}
         const { client: queryClient, ...queryOptions } = queryConfig
         const queryKey = queryOptions?.queryKey ?? auditReportsGetGipMetadataParamsForOrderQueryKey(params)
         

         const query = useQuery({
          ...auditReportsGetGipMetadataParamsForOrderQueryOptions(params, config),
          queryKey,
          ...queryOptions
         } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<AuditReportsGetGipMetadataParamsForOrder401 | AuditReportsGetGipMetadataParamsForOrder403>> & { queryKey: TQueryKey }

         query.queryKey = queryKey as TQueryKey

         return query
         
}